const CatalogFlagDrawerView = () => import('@/views/SuperAdmin/CatalogFlagDrawerView')
const CatalogFlagManagerView = () => import('@/views/SuperAdmin/CatalogFlagManagerView')

export default [
	{
		component: CatalogFlagManagerView,
		name: 'sa-flags',
		path: 'flags',
		children: [
			{
				component: CatalogFlagDrawerView,
				name: 'sa-flags-catalog-flag',
				path: ':catalogFlagId',
				props: route => {
					const catalogFlagId = route.params.catalogFlagId !== 'create'
						? Number.parseInt(route.params.catalogFlagId)
						: null;

					return { value: catalogFlagId };
				}
			}
		]
	}
]
